






import { defineComponent } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { BannerType, SlideType } from '~/types/solepro/PageBuilder';
import Slide from './Slide.vue';

export default defineComponent({
    mixins: [PageBuilderComponent],
    components: {
        Slide
    },
    props: {
        node: {
            type: Object as PropType<BannerType>,
            required: true
        }
    },
    setup(props) {
        const { node: content } = props;
        return {
            content,
            slide: { ...props.node, contentType: 'slide', slideName: '' } as SlideType
        }
    },
})
